/** @format */

import {
  TActionLoginRequest,
  TActionLoginSuccess,
  TActionLoginFailure,
  TActionLogoutRequest,
  TActionLogoutSuccess,
  TActionLogoutFailure,
  TActionFailureApiKeyCheck,
  TActionSuccessApiKeyCheck,
  TActionStartApiKeyCheck,
  TActionEndApiKeyCheck,
  TActionLoginReset,
} from "../declarations/actions/auth";
import { TActionType } from "../declarations/actionTypes";
import { TAPILoginRequest } from "../declarations/apis/auth";
import { TUser } from "../declarations/maps/auth";
import { TAPIValidationError } from "../declarations/apis/general";

export const actionLoginRequest = (payload: TAPILoginRequest): TActionLoginRequest => ({
  type: TActionType.loginRequest,
  payload,
});

export const actionLoginSuccess = (payload: TUser): TActionLoginSuccess => ({
  type: TActionType.loginSuccess,
  payload: payload,
});

export const actionLoginFailure = (payload: TAPIValidationError): TActionLoginFailure => ({
  type: TActionType.loginFailure,
  payload,
});

export const actionLoginReset = (): TActionLoginReset => ({
  type: TActionType.loginReset,
});

export const actionLogoutRequest = (): TActionLogoutRequest => ({
  type: TActionType.logoutRequest,
});

export const actionLogoutSuccess = (): TActionLogoutSuccess => ({
  type: TActionType.logoutSuccess,
});

export const actionLogoutFailure = (): TActionLogoutFailure => ({
  type: TActionType.logoutFailure,
});

export const actionStartApiKeyCheck = (): TActionStartApiKeyCheck => ({
  type: TActionType.startCheckStatus,
});

export const actionSuccessApiKeyCheck = (): TActionSuccessApiKeyCheck => ({
  type: TActionType.successCheckStatus,
});

export const actionFailureApiKeyCheck = (reason: string): TActionFailureApiKeyCheck => ({
  type: TActionType.failureCheckStatus,
  reason,
});

export const actionEndApiKeyCheck = (): TActionEndApiKeyCheck => ({
  type: TActionType.endCheckStatus,
});
